import axios from 'axios'

export const fetchCollectorStats = () => axios.get('/stats')
